// Mock data for PrisamtechAI LLC

export const companyInfo = {
  name: "PRISAMTECHAI",
  tagline: "Strategic IT Talent. Delivered.",
  description: "Elite consulting and staffing solutions for the modern enterprise",
  foundedYear: 2025,
  location: "New York",
  serviceArea: "Nationwide"
};

export const stats = [
{ id: 1, label: "Successful Placements", value: 500, suffix: "+" },
{ id: 2, label: "Enterprise Clients", value: 150, suffix: "+" },
{ id: 3, label: "Countries Served", value: 12, suffix: "" },
{ id: 4, label: "Client Satisfaction", value: 98, suffix: "%" }];


export const services = [
{
  id: 1,
  title: "IT Staffing",
  description: "Direct hire, Contract-to-Hire, and C2C staffing for specialized technical roles. We connect you with top-tier talent.",
  features: ["Direct Hire", "Contract-to-Hire", "C2C Staffing", "Specialized Roles"],
  icon: "users"
},
{
  id: 2,
  title: "IT Consulting",
  description: "Project-based solutions in Cloud migration, Cybersecurity audits, and AI workflows tailored to your business needs.",
  features: ["Cloud Migration", "Cybersecurity", "AI Integration", "Digital Transformation"],
  icon: "lightbulb"
},
{
  id: 3,
  title: "Managed Services",
  description: "End-to-end management of your IT infrastructure so you can focus on growth and innovation.",
  features: ["24/7 Support", "Infrastructure Management", "Proactive Monitoring", "Security Management"],
  icon: "settings"
}];


export const aboutContent = {
  title: "About PrisamTechAi LLC",
  subtitle: "Your Trusted IT Partner",
  description: "PrisamTechAi LLC is a premier IT consulting and staffing firm dedicated to connecting businesses with exceptional technology talent. Founded in 2025, we've grown to become a trusted partner for enterprises seeking strategic IT solutions.",
  paragraphs: [
  "We understand that in today's rapidly evolving digital landscape, having the right talent and technology infrastructure is critical to success. Our team of experienced recruiters and consultants work closely with clients to understand their unique needs and deliver tailored solutions.",
  "Whether you're looking to scale your team, migrate to the cloud, or transform your IT operations, PrisamtechAI has the expertise and network to make it happen."],

  values: [
  { label: "Excellence", description: "We deliver only the best" },
  { label: "Integrity", description: "Honest and transparent partnerships" },
  { label: "Innovation", description: "Cutting-edge solutions" },
  { label: "Commitment", description: "Dedicated to your success" }]

};

export const contactFormSubmit = (formData) => {
  // Mock form submission - will be replaced with actual API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted (MOCK):", formData);
      resolve({
        success: true,
        message: "Thank you! We'll get back to you within 24 hours.",
        data: formData
      });
    }, 1000);
  });
};